import Admin from 'pages/Admin';
import AiUsage from 'pages/Admin/AiUsage';
import IntegrationStatus from 'pages/Admin/IntegrationStatus';
import AdminCampaigns from 'pages/AdminCampaigns';
import AdminOnboarding from 'pages/AdminOnboarding';
import AssignClient from 'pages/AssignClient';
import AutolandClient from 'pages/AutolandClient';
import AutolandDemo from 'pages/AutolandDemo';
import AutosRelifCarDetail from 'pages/AutosRelif/CarDetail';
import RelifCRM from 'pages/AutosRelif/Client';
import RelifCRMDemo from 'pages/AutosRelif/Demo';
import AutosRelifLandingPage from 'pages/AutosRelif/LandingPage';
import BciSegurosQuoteForm from 'pages/BciSegurosQuoteForm';
import BranchOffices from 'pages/BranchOffices';
import BrokerDashboard from 'pages/BrokerDashboard';
import BrunoFritschClient from 'pages/BrunoFritschClient';
import BrunoFritschDemo from 'pages/BrunoFritschDemo';
import BusinessUnitCharts from 'pages/BusinessUnitCharts';
import BusinessUnitConfig from 'pages/BusinessUnitConfig';
import BusinessUnits from 'pages/BusinessUnits';
import CampaignsControlPanel from 'pages/CampaignsControlPanel';
import CarModels from 'pages/CarModels';
import Cars from 'pages/Cars';
import EditCar from 'pages/Cars/EditCar';
import Client from 'pages/Client';
import Clients from 'pages/Clients';
import ConversationEvals from 'pages/ConversationEvals';
import Dashboard from 'pages/Dashboard';
import DbReader from 'pages/DbReader';
import Demochat from 'pages/Demochat';
import NewDemochat from 'pages/Demochat/NewChat';
import DesignSystem from 'pages/DesignSystem';
import ErrorPage from 'pages/Error/ErrorPage';
import FollowUpConfig from 'pages/FollowUpConfig';
import GoogleIntegrations from 'pages/GoogleIntegrations';
import InstagramIntegrationStart from 'pages/InstagramIntegrationStart';
import InstagramIntegrationSuccess from 'pages/InstagramIntegrationSuccess';
import InsuranceCredentials from 'pages/InsuranceCredentials';
import InsuranceQuoteForm from 'pages/InsuranceQuoteForm';
import Labs from 'pages/Labs';
import LandingPage from 'pages/LandingPage';
import Leads from 'pages/Leads';
import MetaConfig from 'pages/MetaConfig';
import OnboardingCarDealership from 'pages/OnboardingCarDealership';
import OnboardingInsuranceBroker from 'pages/OnboardingInsuranceBroker';
import OnboardingLanding from 'pages/OnboardingLanding';
import PasswordReset from 'pages/PasswordReset';
import Playground from 'pages/Playground';
import PompeyoClient from 'pages/PompeyoClient';
import PompeyoDemo from 'pages/PompeyoDemo';
import PrivacyPolicy from 'pages/PrivacyPolicy';
import Profile from 'pages/Profile';
import PromptSections from 'pages/PromptSections';
import PublicChat from 'pages/PublicChat';
import RealtimeVoice from 'pages/RealtimeVoice';
import RelifDashboard from 'pages/RelifDashboard';
import Reports from 'pages/Reports';
import PublicReportView from 'pages/Reports/PublicReportView';
import ReportDetailNew from 'pages/Reports/ReportDetail';
import Sales from 'pages/Sales';
import SellerManagementPage from 'pages/SellerManagement';
import ServiceCalendar from 'pages/ServiceCalendar';
import SetupOnboarding from 'pages/SetupOnboarding';
import ConfigureLinks from 'pages/SetupOnboarding/ConfigureLinks';
import SignIn from 'pages/SignIn';
import SuccessStories from 'pages/SuccessStories';
import SuccessStoryDetail from 'pages/SuccessStories/SuccessStoryDetail';
import Surveys from 'pages/Surveys';
import SurveysResults from 'pages/SurveysResults';
import Ticket from 'pages/Ticket';
import Tickets from 'pages/Tickets';
import TyC from 'pages/TyC';
import Unauthorized from 'pages/Unauthorized';
import UrlsForm from 'pages/UrlsForm';
import Users from 'pages/Users';
import WhatsAppHealth from 'pages/WhatsAppHealth';
import WhatsAppIntegrationSuccess from 'pages/WhatsAppIntegrationSuccess';
import WhoWeAre from 'pages/WhoWeAre';
import WidgetChat from 'pages/WidgetChat';
import PresentationDeck from 'pages/Presentations/Deck';
import Presentations from 'pages/Presentations';
import { type FunctionComponent, lazy } from 'react';

const Icons = lazy(() => import('pages/Icons'));

export type Role = 'admin' | 'businessUnitAdmin' | 'branchManager' | 'seller' | 'sellerWithAssignment';

export type Route = {
  title: string;
  path: string;
  regex?: RegExp;
  component: FunctionComponent;
  private: boolean;
  index: boolean;
  noLayout?: boolean;
  role?: Role[];
  ignoreMobileSidebarMenuButton?: boolean;
};

const routes: { [key: string]: Route } = {
  '/sign-in': {
    title: 'Iniciar Sesión',
    path: '/sign-in',
    component: SignIn,
    private: false,
    index: false,
  },
  '/onboarding': {
    title: 'Registro de Empresa',
    path: '/onboarding',
    component: OnboardingLanding,
    private: false,
    index: false,
  },
  '/onboarding/car-dealership': {
    title: 'Registro de Concesionaria',
    path: '/onboarding/car-dealership',
    component: OnboardingCarDealership,
    private: false,
    index: false,
  },
  '/onboarding/insurance-broker': {
    title: 'Registro de Corredora de Seguros',
    path: '/onboarding/insurance-broker',
    component: OnboardingInsuranceBroker,
    private: false,
    index: false,
  },

  '/dashboard': {
    title: 'Dashboard',
    path: '/dashboard',
    component: Dashboard,
    private: true,
    index: false,
    role: ['admin', 'businessUnitAdmin', 'branchManager'],
  },
  '/setup-onboarding': {
    title: 'Configuración Inicial',
    path: '/setup-onboarding',
    component: SetupOnboarding,
    private: true,
    index: false,
    role: ['admin', 'businessUnitAdmin'],
  },
  '/setup-onboarding/configure-links': {
    title: 'Configurar Enlaces de Inventario',
    path: '/setup-onboarding/configure-links',
    component: ConfigureLinks,
    private: true,
    index: false,
    role: ['admin', 'businessUnitAdmin'],
  },
  '/reports': {
    title: 'Reportes',
    path: '/reports',
    component: Reports,
    private: true,
    index: false,
    role: ['admin', 'businessUnitAdmin', 'branchManager'],
  },
  '/reports/:reportId': {
    title: 'Detalle del Reporte',
    path: '/reports/:reportId',
    regex: /\/reports\/\d+/,
    component: ReportDetailNew,
    private: true,
    index: false,
    role: ['admin', 'businessUnitAdmin', 'branchManager'],
  },
  '/': {
    title: 'Bienvenido',
    path: '/',
    component: LandingPage,
    private: false,
    index: false,
    noLayout: true,
  },
  '/quienes-somos': {
    title: 'Quiénes Somos',
    path: '/quienes-somos',
    component: WhoWeAre,
    private: false,
    index: false,
  },
  '/admin': {
    title: 'Administrador',
    path: '/admin',
    component: Admin,
    private: true,
    index: false,
    role: ['admin'],
  },
  '/integration-status': {
    title: 'Monitoreo de Salud',
    path: '/integration-status',
    component: IntegrationStatus,
    private: true,
    index: false,
    role: ['admin'],
  },
  '/ai-usage': {
    title: 'Uso de IA',
    path: '/ai-usage',
    component: AiUsage,
    private: true,
    index: false,
    role: ['admin'],
  },
  '/clients/:clientId': {
    title: 'Chat WhatsApp',
    path: '/clients/:clientId',
    regex: /\/clients\/\d+/,
    component: Client,
    private: true,
    index: false,
    role: ['admin', 'businessUnitAdmin', 'branchManager', 'seller'],
    ignoreMobileSidebarMenuButton: true,
  },
  '/businessUnits': {
    title: 'Empresas',
    path: '/businessUnits',
    component: BusinessUnits,
    private: true,
    index: false,
    role: ['admin'],
  },
  '/businessUnits/new': {
    title: 'Nueva Business Unit',
    path: '/businessUnits/new',
    component: AdminOnboarding,
    private: true,
    index: false,
    role: ['admin'],
  },
  '/businessUnit-follow-up-config/:businessUnitId': {
    title: 'Follow Ups',
    path: '/businessUnit-follow-up-config/:businessUnitId',
    regex: /\/businessUnit-follow-up-config\/\d+/i,
    component: FollowUpConfig,
    private: true,
    index: false,
    role: ['admin'],
  },
  '/businessUnit-config/:businessUnitId': {
    title: 'Empresa Configuraciones',
    path: '/businessUnit-config/:businessUnitId',
    regex: /\/businessUnit-config\/\d+/i,
    component: BusinessUnitConfig,
    private: true,
    index: false,
    role: ['admin'],
  },
  '/businessUnit-charts': {
    title: 'Costos',
    path: '/businessUnit-charts',
    component: BusinessUnitCharts,
    private: true,
    index: false,
    role: ['admin'],
  },
  '/sales': {
    title: 'Ventas',
    path: '/sales',
    component: Sales,
    private: true,
    index: false,
    role: ['admin', 'businessUnitAdmin', 'branchManager', 'seller', 'sellerWithAssignment'],
  },
  '/tickets': {
    title: 'Tickets de soporte',
    path: '/tickets',
    component: Tickets,
    private: true,
    index: false,
    role: ['admin', 'businessUnitAdmin', 'branchManager', 'seller', 'sellerWithAssignment'],
  },
  '/tickets/:ticketId': {
    title: 'Ticket de soporte',
    path: '/tickets/:ticketId',
    regex: /\/tickets\/\d+/,
    component: Ticket,
    private: true,
    index: false,
    role: ['admin', 'businessUnitAdmin', 'branchManager', 'seller', 'sellerWithAssignment'],
  },
  '/cars': {
    title: 'Autos',
    path: '/cars',
    component: Cars,
    private: true,
    index: false,
    role: ['admin', 'businessUnitAdmin', 'branchManager'],
  },
  '/calendar': {
    title: 'Agenda',
    path: '/calendar',
    component: ServiceCalendar,
    private: true,
    index: false,
    role: ['admin', 'businessUnitAdmin', 'branchManager', 'seller'],
  },
  '/cars/:carId/edit': {
    title: 'Editar Auto',
    path: '/cars/:carId/edit',
    regex: /\/cars\/\d+\/edit/,
    component: EditCar,
    private: true,
    index: false,
    role: ['admin', 'businessUnitAdmin', 'branchManager'],
  },
  '/branch-offices': {
    title: 'Sucursales',
    path: '/branch-offices',
    component: BranchOffices,
    private: true,
    index: false,
    role: ['admin', 'businessUnitAdmin', 'branchManager'],
  },
  '/carModels': {
    title: 'Modelos de Autos',
    path: '/carModels',
    component: CarModels,
    private: true,
    index: false,
    role: ['admin'],
  },
  '/information': {
    title: 'Información',
    path: '/information',
    component: PromptSections,
    private: true,
    index: false,
    role: ['admin', 'businessUnitAdmin'],
  },
  '/users': {
    title: 'Usuarios',
    path: '/users',
    component: Users,
    private: true,
    index: false,
    role: ['admin', 'businessUnitAdmin', 'branchManager'],
  },
  '/clients': {
    title: 'Clientes',
    path: '/clients',
    component: Clients,
    private: true,
    index: false,
    role: ['admin', 'businessUnitAdmin', 'branchManager', 'seller'],
  },
  '/icons': {
    title: 'Icons',
    path: '/icons',
    component: Icons,
    private: true,
    index: false,
    role: ['admin'],
  },
  '/unauthorized': {
    title: 'Unauthorized',
    path: '/unauthorized',
    component: Unauthorized,
    private: true,
    index: false,
    role: ['admin', 'businessUnitAdmin', 'branchManager', 'seller'],
  },
  '/tyc': {
    title: 'Términos y Condiciones',
    path: '/tyc',
    component: TyC,
    private: false,
    index: false,
  },
  '/db-reader': {
    title: 'Analizador de Base de Datos',
    path: '/db-reader',
    component: DbReader,
    private: true,
    index: false,
    role: ['admin'],
  },
  '/playground': {
    title: 'Playground',
    path: '/playground',
    component: Playground,
    private: true,
    index: false,
    noLayout: true,
    role: ['admin'],
  },
  '/playground/:messageId': {
    title: 'Playground',
    path: '/playground/:messageId',
    regex: /\/playground\/\d+/,
    component: Playground,
    private: true,
    index: false,
    noLayout: true,
    role: ['admin'],
  },
  '/publicChat': {
    title: 'Public Chat',
    path: '/publicChat',
    component: PublicChat,
    private: false,
    index: false,
    noLayout: true,
  },
  '/autoland-client': {
    title: 'Autoland - Cliente',
    path: '/autoland-client',
    regex: /\/autoland-client/,
    component: AutolandClient,
    private: false,
    index: false,
    noLayout: true,
  },
  '/autoland-demo': {
    title: 'Autoland - Demo',
    path: '/autoland-demo',
    component: AutolandDemo,
    private: false,
    index: false,
    noLayout: true,
  },
  '/bruno-fritsch-client': {
    title: 'Bruno Fritsch - Cliente',
    path: '/bruno-fritsch-client',
    regex: /\/bruno-fritsch-client/,
    component: BrunoFritschClient,
    private: false,
    index: false,
    noLayout: true,
  },
  '/bruno-fritsch-demo': {
    title: 'Bruno Fritsch - Demo',
    path: '/bruno-fritsch-demo',
    component: BrunoFritschDemo,
    private: false,
    index: false,
    noLayout: true,
  },
  '/pompeyo-client': {
    title: 'Pompeyo - Cliente',
    path: '/pompeyo-client',
    regex: /\/pompeyo-client/,
    component: PompeyoClient,
    private: false,
    index: false,
    noLayout: true,
  },
  '/pompeyo-demo': {
    title: 'Pompeyo - Demo',
    path: '/pompeyo-demo',
    component: PompeyoDemo,
    private: false,
    index: false,
    noLayout: true,
  },
  '/WhatsAppIntegrationSuccess': {
    title: 'Relif Integración WhatsApp',
    path: '/WhatsAppIntegrationSuccess',
    regex: /WhatsAppIntegrationSuccess/i,
    component: WhatsAppIntegrationSuccess,
    private: false,
    index: false,
    noLayout: true,
  },
  '/InstagramIntegrationSuccess': {
    title: 'Relif Integración Instagram',
    path: '/InstagramIntegrationSuccess',
    regex: /InstagramIntegrationSuccess/i,
    component: InstagramIntegrationSuccess,
    private: false,
    index: false,
    noLayout: true,
  },
  '/InstagramIntegrationStart': {
    title: 'Relif Conectar Instagram',
    path: '/InstagramIntegrationStart',
    regex: /InstagramIntegrationStart/i,
    component: InstagramIntegrationStart,
    private: false,
    index: false,
    noLayout: true,
  },
  '/demochat': {
    title: 'Demo Chat',
    path: '/demochat',
    component: ErrorPage,
    private: false,
    index: false,
    noLayout: true,
  },
  '/demochat/:companyIdentifier': {
    title: 'Demo Chat',
    path: '/demochat/:companyIdentifier',
    component: Demochat,
    private: false,
    index: false,
    noLayout: true,
  },
  '/demochat/:companyIdentifier/newchat': {
    title: 'New Demo Chat',
    path: '/demochat/:companyIdentifier/newchat',
    component: NewDemochat,
    private: false,
    index: false,
    noLayout: true,
  },
  '/widgetChat': {
    title: 'Widget Chat',
    path: '/widgetChat',
    component: WidgetChat,
    private: false,
    index: false,
    noLayout: true,
  },
  '/widgetChat/:companyIdentifier': {
    title: 'Widget Chat',
    path: '/widgetChat/:companyIdentifier',
    component: WidgetChat,
    private: false,
    index: false,
    noLayout: true,
  },
  '/design-system': {
    title: 'Design System',
    path: '/design-system',
    component: DesignSystem,
    private: true,
    index: false,
    noLayout: true,
    role: ['admin'],
  },
  '/profile': {
    title: 'Perfil',
    path: '/profile',
    component: Profile,
    private: true,
    index: false,
    role: ['admin', 'businessUnitAdmin', 'branchManager', 'seller'],
  },
  '/google-integrations': {
    title: 'Integraciones Google',
    path: '/google-integrations',
    component: GoogleIntegrations,
    private: true,
    index: false,
    role: ['admin'],
  },
  '/leads': {
    title: 'Leads',
    path: '/leads',
    component: Leads,
    private: true,
    index: false,
    role: ['admin', 'businessUnitAdmin', 'branchManager', 'sellerWithAssignment'],
  },
  '/mis-ejecutivos': {
    title: 'Mis Ejecutivos',
    path: '/mis-ejecutivos',
    component: SellerManagementPage,
    private: true,
    index: false,
    role: ['admin', 'businessUnitAdmin', 'branchManager'],
  },
  '/realtimeVoice/:companyIdentifier': {
    title: 'Realtime Voice',
    path: '/realtimeVoice/:companyIdentifier',
    regex: /\/realtimeVoice\/[\w-]+/,
    component: RealtimeVoice,
    private: false,
    index: false,
    noLayout: true,
  },
  '/conversation-evals': {
    title: 'Conversation Evals',
    path: '/conversation-evals',
    component: ConversationEvals,
    private: true,
    index: false,
    role: ['admin'],
  },
  '/labs': {
    title: 'Labs',
    path: '/labs',
    component: Labs,
    private: true,
    index: false,
    role: ['admin'],
  },
  '/relif-dashboard': {
    title: 'Relif Dashboard',
    path: '/relif-dashboard',
    component: RelifDashboard,
    private: true,
    index: false,
    role: ['admin'],
  },
  '/urls-form': {
    title: 'URLs Form',
    path: '/urls-form',
    component: UrlsForm,
    private: true,
    index: false,
    role: ['admin'],
  },
  '/surveys': {
    title: 'Encuestas',
    path: '/surveys',
    component: Surveys,
    private: true,
    index: false,
  },
  '/meta-config': {
    title: 'Meta Ads',
    path: '/meta-config',
    component: MetaConfig,
    private: true,
    index: false,
    role: ['admin', 'businessUnitAdmin'],
  },
  '/politica-privacidad-zeller-ads': {
    title: 'Política de Privacidad',
    path: '/politica-privacidad-zeller-ads',
    component: PrivacyPolicy,
    private: false,
    index: false,
  },
  '/campaigns-stats': {
    title: 'Control de Campañas',
    path: '/campaigns-stats',
    component: CampaignsControlPanel,
    private: true,
    index: false,
    role: ['admin', 'businessUnitAdmin'],
  },
  '/surveys-results': {
    title: 'Resultados Encuestas',
    path: '/surveys-results',
    component: SurveysResults,
    private: true,
    index: false,
    role: ['admin', 'businessUnitAdmin', 'branchManager'],
  },
  '/whatsapp-health': {
    title: 'Salud WhatsApp',
    path: '/whatsapp-health',
    component: WhatsAppHealth,
    private: true,
    index: false,
    role: ['admin', 'businessUnitAdmin', 'branchManager'],
  },
  '/casos-de-exito': {
    title: 'Casos de éxito',
    path: '/casos-de-exito',
    component: SuccessStories,
    private: false,
    index: false,
  },
  '/casos-de-exito/:storyId': {
    title: 'Caso de éxito',
    path: '/casos-de-exito/:storyId',
    regex: /\/casos-de-exito\/\d+/,
    component: SuccessStoryDetail,
    private: false,
    index: false,
  },
  '/password-reset': {
    title: 'Resetear Contraseña',
    path: '/password-reset',
    component: PasswordReset,
    private: false,
    index: false,
  },
  '/assign-client': {
    title: 'Asignar Cliente',
    path: '/assign-client',
    component: AssignClient,
    private: true,
    index: false,
  },
  '/insurance-credentials': {
    title: 'Credenciales de Seguros',
    path: '/insurance-credentials',
    component: InsuranceCredentials,
    private: true,
    index: false,
    role: ['admin', 'businessUnitAdmin'],
  },
  '/admin-campaigns': {
    title: 'Campañas de WhatsApp (Admin)',
    path: '/admin-campaigns',
    component: AdminCampaigns,
    private: true,
    index: false,
  },
  '/autosrelif': {
    title: 'AutosRelif',
    path: '/autosrelif',
    component: AutosRelifLandingPage,
    private: false,
    index: false,
    noLayout: true,
  },
  '/autosrelif/detalle/:hash': {
    title: 'AutosRelif - Detalle',
    path: '/autosrelif/detalle/:hash',
    regex: /\/autosrelif\/detalle\/\w+/,
    component: AutosRelifCarDetail,
    private: false,
    index: false,
    noLayout: true,
  },
  '/autosrelif-client': {
    title: 'AutosRelif - Cliente',
    path: '/autosrelif-client',
    regex: /\/autosrelif-client/,
    component: RelifCRM,
    private: false,
    index: false,
    noLayout: true,
  },
  '/autosrelif-demo': {
    title: 'AutosRelif - Demo',
    path: '/autosrelif-demo',
    component: RelifCRMDemo,
    private: false,
    index: false,
    noLayout: true,
  },
  '/shared-report': {
    title: 'Reporte Compartido',
    path: '/shared-report',
    component: PublicReportView,
    private: false,
    index: false,
    noLayout: true,
  },
  '/insurance-quote-form': {
    title: 'Cotizar Seguro de Auto',
    path: '/insurance-quote-form',
    component: InsuranceQuoteForm,
    private: true,
    index: false,
    role: ['admin', 'businessUnitAdmin', 'branchManager', 'seller'],
  },
  '/bci-seguros-quote': {
    title: 'Cotizar BCI Seguros',
    path: '/bci-seguros-quote',
    component: BciSegurosQuoteForm,
    private: true,
    index: false,
    role: ['admin', 'businessUnitAdmin', 'branchManager', 'seller'],
  },
  '/broker-dashboard': {
    title: 'Cotizaciones',
    path: '/broker-dashboard',
    component: BrokerDashboard,
    private: true,
    index: false,
    role: ['admin', 'businessUnitAdmin', 'branchManager', 'seller'],
  },
  '/presentations': {
    title: 'Presentaciones',
    path: '/presentations',
    component: Presentations,
    private: false,
    index: false,
    noLayout: true,
  },
  '/presentations/:slug': {
    title: 'Presentaciones',
    path: '/presentations/:slug',
    component: PresentationDeck,
    private: false,
    index: false,
    noLayout: true,
  },
  // this path must be the last one
  error: {
    title: 'Error',
    path: '*',
    component: ErrorPage,
    private: true,
    index: false,
    role: ['admin', 'businessUnitAdmin', 'branchManager', 'seller'],
  },
};

export default routes;
